export const IsomerLogo = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="86"
      height="24"
      viewBox="0 0 86 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_1940_51915"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="7"
        width="11"
        height="17"
      >
        <path
          d="M10.9434 7.57031H20.8902V24.0012H10.9434V7.57031Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1940_51915)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.8016 19.1944C19.8016 19.1944 18.0555 20.4305 15.9168 21.7167C13.778 23.003 12.0315 23.868 12.0315 23.868C11.5163 24.1778 11.0987 23.9303 11.0987 23.3158C11.0987 23.3158 10.9434 21.1377 10.9434 18.7732C10.9434 16.4083 11.0987 14.0439 11.0987 14.0439C11.0987 13.4289 11.5163 12.6792 12.0315 12.3694C12.0315 12.3694 13.7036 11.1784 15.9168 9.84758C18.1294 8.51579 19.8016 7.69577 19.8016 7.69577C20.3168 7.38598 20.6837 7.68007 20.7343 8.24751C20.7849 8.81597 20.8902 9.77621 20.8902 12.7901C20.8902 15.8039 20.7343 17.5199 20.7343 17.5199C20.7343 18.1344 20.3168 18.8841 19.8016 19.1939"
          fill="#2B5FCE"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6085 15.2174L18.2061 14.038C18.0168 13.8785 17.7729 13.9301 17.6646 14.1524L16.8133 15.8911L16.8143 15.8942L15.2115 14.5457C15.0223 14.3867 14.7783 14.4384 14.67 14.6606L12.0783 19.9579C11.9695 20.1801 12.054 20.2575 12.2655 20.13L17.3012 17.1014L19.5675 15.7388C19.7791 15.6112 19.7978 15.3763 19.6085 15.2174Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1138 13.1309C17.1138 13.3774 16.9463 13.6781 16.7393 13.8026C16.5323 13.9267 16.3647 13.8279 16.3647 13.5809C16.3647 13.3344 16.5323 13.0337 16.7393 12.9092C16.9463 12.7847 17.1138 12.8839 17.1138 13.1309Z"
        fill="#B99BF9"
      />
      <mask
        id="mask1_1940_51915"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="7"
        width="10"
        height="17"
      >
        <path d="M0 7.58594H9.94884V24.0002H0V7.58594Z" fill="white" />
      </mask>
      <g mask="url(#mask1_1940_51915)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.158029 17.5187C0.158029 17.5187 0.00215179 15.8027 0.00215179 12.7888C-0.0185982 10.0083 0.11653 8.77219 0.158029 8.24677C0.199529 7.72185 0.551266 7.40751 1.09076 7.69502C1.09076 7.69502 2.76291 8.51505 4.97556 9.84582C7.18872 11.1766 8.86036 12.3677 8.86036 12.3677C9.37556 12.6775 9.7936 13.4271 9.7936 14.0421C9.7936 14.0421 9.94897 16.4066 9.94897 18.7715C9.94897 21.1359 9.7936 23.314 9.7936 23.314C9.7936 23.9285 9.37556 24.1761 8.86036 23.8658C8.86036 23.8658 7.11432 23.0012 4.97556 21.7145C3.65317 20.9169 2.35753 20.0759 1.09076 19.1926C0.575559 18.8828 0.158029 18.1332 0.158029 17.5192"
          fill="#2B5FCE"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.1636 11.5223L1.5319 9.91919C1.41448 9.84427 1.31934 9.88882 1.31934 10.0184V17.2266C1.31934 17.3566 1.41448 17.5227 1.5319 17.5971L4.1636 19.2007C4.28152 19.2756 4.37666 19.2311 4.37666 19.1015V11.8933C4.37666 11.7632 4.28152 11.5972 4.1641 11.5223H4.1636ZM8.06914 14.0811L5.23753 12.2785C5.12012 12.2036 5.02497 12.2482 5.02497 12.3778V15.301C5.02497 15.4306 5.12012 15.5961 5.23753 15.6705L8.06914 17.4736C8.18656 17.5485 8.2817 17.5039 8.2817 17.3744V14.4511C8.2817 14.3215 8.18656 14.156 8.06914 14.0816"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.06857 21.7584L5.23746 19.9564C5.12005 19.8814 5.0249 19.7154 5.0249 19.5858V16.6631C5.0249 16.5335 5.12005 16.489 5.23746 16.5634L8.06857 18.3659C8.18649 18.4408 8.28113 18.6069 8.28113 18.7364V21.6592C8.28113 21.7888 8.18649 21.8333 8.06857 21.7584Z"
        fill="#B99BF9"
      />
      <mask
        id="mask2_1940_51915"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="12"
      >
        <path d="M0.888184 0H19.9326V11.1316H0.888184V0Z" fill="white" />
      </mask>
      <g mask="url(#mask2_1940_51915)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5513 6.13798C19.5513 6.13798 17.8888 7.30222 15.6529 8.61123C14.2698 9.41887 12.8604 10.1804 11.4269 10.8947C10.8885 11.21 10.0124 11.211 9.47038 10.8962C9.47038 10.8962 7.3053 9.82963 5.22069 8.61983C3.13608 7.41004 1.29642 6.15317 1.29642 6.15317C0.754391 5.83832 0.75186 5.32808 1.29035 5.01222C1.29035 5.01222 2.87544 3.89353 5.18881 2.53897C6.57057 1.7291 7.98006 0.967497 9.41471 0.255544C9.9532 -0.0598128 10.6612 -0.108913 11.3718 0.253519C12.0818 0.616458 12.9645 0.988508 15.621 2.53036C18.278 4.07222 19.0619 4.6594 19.5452 4.99703C20.0291 5.33516 20.0903 5.82212 19.5513 6.13798Z"
          fill="#2B5FCE"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0225 4.66798C6.68898 4.47461 6.74567 4.28327 7.14903 4.2443L11.3365 3.83175C11.7393 3.79227 11.9792 4.07978 11.8684 4.47006L11.3395 6.3465C11.2297 6.73728 10.8668 6.89876 10.5333 6.7059L7.0225 4.66798Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5584 5.44854L10.2453 9.73091L9.75488 9.44593L17.068 5.16406L17.5584 5.44854Z"
        fill="#B99BF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0229 8.40318C12.3392 8.58642 12.3407 8.88406 12.0265 9.06781C11.7127 9.25206 11.2015 9.25257 10.8857 9.06882C10.5694 8.88558 10.5679 8.58794 10.8822 8.40369C11.1959 8.21994 11.7071 8.21944 12.0229 8.40318Z"
        fill="white"
      />
      <mask
        id="mask3_1940_51915"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="27"
        y="4"
        width="59"
        height="15"
      >
        <path
          d="M27.937 4.78125H85.2949V18.6311H27.937V4.78125Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_1940_51915)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.3817 18.0951V9.50957C79.3817 9.28078 79.5047 9.14917 79.7415 9.14917H81.7538C81.9825 9.14917 82.1141 9.28078 82.1141 9.50957V10.318C82.1141 10.6429 82.2897 10.7133 82.5094 10.4496C83.1215 9.73211 83.9687 9.25561 84.8997 9.10513C85.1542 9.06109 85.2944 9.20181 85.2944 9.43921V11.4336C85.2944 11.6447 85.172 11.794 84.9346 11.794C83.1774 11.8821 82.2548 12.6029 82.2548 14.2288V18.0951C82.2548 18.333 82.1318 18.4555 81.8945 18.4555H79.7415C79.5047 18.4555 79.3817 18.3325 79.3817 18.0951ZM74.7357 12.6029C74.9903 12.6029 75.1305 12.4622 75.0429 12.2071C74.7616 11.4341 74.0586 10.9856 73.1451 10.9856C72.2311 10.9856 71.5104 11.425 71.1683 12.1899C71.0625 12.4445 71.2209 12.6029 71.4755 12.6029H74.7352H74.7357ZM68.1448 13.8061C68.1448 11.0995 70.1834 8.9553 73.1183 8.9553C75.7894 8.9553 77.8538 10.7745 77.8806 13.6745L77.8715 13.9291C77.8538 14.1402 77.7222 14.2718 77.5026 14.2718H71.3616C71.1328 14.2718 70.9658 14.4125 71.0362 14.6671C71.2558 15.7747 72.1435 16.3897 73.2154 16.3897C73.9796 16.3897 74.674 16.0911 75.1219 15.4846C75.2626 15.3004 75.4119 15.23 75.6052 15.3267L77.2131 16.0035C77.4327 16.0911 77.5117 16.2495 77.4155 16.4251C76.6508 17.7868 75.1573 18.6306 73.2149 18.6306C70.1399 18.6306 68.1454 16.5046 68.1454 13.8066L68.1448 13.8061ZM52.6214 18.0946V9.50957C52.6214 9.28078 52.7443 9.14917 52.9817 9.14917H55.1341C55.3715 9.14917 55.4945 9.28078 55.4945 9.50957V9.85226C55.4945 10.1772 55.6701 10.2299 55.8983 9.99299C56.496 9.36025 57.2779 8.97352 58.2183 8.97352C59.3165 8.97352 60.1688 9.33342 60.6779 10.1246C60.81 10.3443 60.9512 10.362 61.1177 10.16C61.7589 9.4215 62.638 8.97352 63.7094 8.97352C65.5815 8.97352 66.8118 10.0365 66.8118 12.0491V18.0951C66.8118 18.333 66.6797 18.4555 66.4509 18.4555H64.2985C64.0612 18.4555 63.9382 18.3325 63.9382 18.0951V12.7608C63.9382 11.838 63.4017 11.2848 62.5849 11.2848C61.6451 11.2848 61.1617 11.9874 61.1617 12.9279V18.0951C61.1617 18.333 61.0301 18.4555 60.8014 18.4555H58.6318C58.3944 18.4555 58.2714 18.3325 58.2714 18.0951V12.7608C58.2714 11.838 57.7532 11.2848 56.9272 11.2848C55.9869 11.2848 55.495 11.9874 55.495 12.9279V18.0951C55.495 18.333 55.372 18.4555 55.1346 18.4555H52.9822C52.7443 18.4555 52.6219 18.3325 52.6219 18.0951L52.6214 18.0946ZM48.3793 13.7975C48.3793 12.365 47.2896 11.3718 45.9449 11.3718C44.5921 11.3718 43.5202 12.3296 43.5202 13.7975C43.5202 15.2736 44.5921 16.2141 45.9454 16.2141C47.2896 16.2141 48.3793 15.2472 48.3793 13.7975ZM40.7964 13.7975C40.7964 10.9588 43.002 8.97301 45.954 8.97301C48.8975 8.97301 51.1203 10.9588 51.1203 13.7975C51.1203 16.6448 48.8975 18.6306 45.954 18.6306C43.002 18.6306 40.7969 16.6448 40.7969 13.7975H40.7964ZM32.6452 17.6385C32.4519 17.5241 32.4165 17.357 32.5308 17.146L33.3042 15.7752C33.4094 15.5641 33.5937 15.5292 33.787 15.679C34.5694 16.1619 35.5796 16.5395 36.3175 16.5395C36.9066 16.5395 37.3018 16.3026 37.3018 15.8456C37.3018 15.2214 36.4668 15.0372 35.4829 14.6945C34.2703 14.2814 32.7945 13.754 32.7945 11.8821C32.7945 9.88719 34.4545 8.97352 36.3706 8.97352C37.4248 8.97352 38.5316 9.23674 39.4806 9.76419C39.6916 9.87859 39.727 10.0456 39.5949 10.2562L38.8221 11.469C38.6986 11.6624 38.5321 11.6978 38.3388 11.5834C37.7062 11.258 36.8974 10.9947 36.3352 10.9947C35.8169 10.9947 35.4657 11.2053 35.4657 11.5834C35.4657 12.1458 36.3529 12.3043 37.3899 12.6378C38.6374 13.06 40.0519 13.6401 40.0519 15.5909C40.0519 17.6471 38.4618 18.6311 36.3615 18.6311C35.0527 18.6311 33.6817 18.2449 32.6452 17.6385ZM28.0954 18.0951V9.50957C28.0954 9.28078 28.2184 9.14917 28.4558 9.14917H30.591C30.8278 9.14917 30.9508 9.28078 30.9508 9.50957V18.0951C30.9508 18.333 30.8278 18.4555 30.591 18.4555H28.4553C28.2184 18.4555 28.0954 18.3325 28.0954 18.0951ZM27.937 6.36309C27.937 5.48435 28.6577 4.78125 29.5449 4.78125C29.9655 4.78125 30.369 4.94839 30.6664 5.2459C30.9639 5.5434 31.131 5.94691 31.131 6.36765C31.131 6.78839 30.9639 7.1919 30.6664 7.4894C30.369 7.78691 29.9655 7.95405 29.5449 7.95405C28.6577 7.95405 27.9375 7.25045 27.9375 6.36309H27.937Z"
          fill="#0B1528"
        />
      </g>
    </svg>
  )
}
